import React from 'react';
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import TransportistaRuta from './TransportistaRuta';
import ACCESS from '../../../ACCESS.js';

class TransportistaRutas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'transportista-ruta/filter', deleteUrl: 'transportista-ruta/delete', deleteField: 'transportista_nombre', modUrl: '/Catalogo/TransportistaRuta' },
      TableOp.Table('Rutas transportista', [
        { label: 'Transportista', id: 'transportista_nombre' },
        { label: 'Circuito', id: 'circuito' },
        { label: 'Costo', id: 'costo' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_RUTAS_TRANSPORTISTA.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_RUTAS_TRANSPORTISTA.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <TransportistaRuta  onSave={() => {this.table()}}></TransportistaRuta>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(TransportistaRutas)